import React, { useState, useEffect } from 'react';
import { TextField, Typography, Box, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { SmartFormStates } from './SmartForm';
import ErrorWrapper from '@component/ErrorWrapper';
import { useTranslation } from "react-i18next";
import { syncValidatorResults } from "@component/smartForm/validatorUtils"

const SmartTextareaInput = ({
  field,
  label,
  value,
  onChange,
  isEdit,
  sx = {},
  valueSx = {},
  renderView,
  maxPreviewLength = 300,
  editable = true,
  validator,
  validatorResults,
  setValidatorResults,
  formState,
  ...props
}) => {

  const [showError, setShowError] = useState(false)
  const [validatorResult, setValidatorResult] = useState("");
  const { t } = useTranslation(["main"]);

  useEffect(() => {
    setShowError(formState === SmartFormStates.SAVING);
  }, [formState]);


  useEffect(() => {
    if (validator) {
      const validatorResult = validator(value);
      syncValidatorResults(validatorResults, setValidatorResults, !validatorResult, label)
      setValidatorResult(validatorResult)
    }

  }, [value, validator, label, setValidatorResults, validatorResults])

  const [expanded, setExpanded] = useState(false);
  const handleChange = (e) => {
    onChange(field, e.target.value);
  };

  const shouldTruncate = value && value.length > maxPreviewLength && !expanded;
  const displayText = shouldTruncate
    ? `${value.substring(0, maxPreviewLength)}...`
    : value;

  return (
    <Box sx={sx}>
      {!isEdit || !editable ? (
        renderView ? (
          renderView(value)
        ) : (
          <>
            {label && (
              <Typography
                variant="caption"
                component="div"
                sx={{
                  color: 'text.secondary',
                  fontSize: '0.75rem',
                  lineHeight: 1.66,
                  mb: 0
                }}
              >
                {label}
              </Typography>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography
                variant="body1"
                sx={{
                  mt: 0.5,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  ...valueSx
                }}
              >
                {displayText || '-'}
              </Typography>
              {value && value.length > maxPreviewLength && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    size="small"
                    onClick={() => setExpanded(!expanded)}
                    startIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    sx={{ mt: 1 }}
                  >
                    {expanded ? t('showLess') : t('showMore')}
                  </Button>
                </Box>
              )}
            </Box>
          </>
        )
      ) : (
        <ErrorWrapper message={validatorResult} showMessage={showError}>
          <TextField
            label={label}
            value={value || ''}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            multiline
             sx={{
              '& .MuiInputBase-root': {
                mt: 0.75, // zvětší vzdálenost mezi input a labelem
              },
            }}
            {...props}
          />
        </ErrorWrapper>
      )}
    </Box>
  );
};

export default SmartTextareaInput;